import styled from 'styled-components';

export const AdminPageWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
`;
export const AdminPageSizeWrap = styled.div`
  width: 95%;
`;
export const AdminTitleWrap = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  &.af-domain-settings-header-wrap {
    align-items: baseline;
    margin-top: 10px;
  }
  .af-superadmin-branding-title-button-wrap {
    display: flex;
    align-content: center;
    column-gap: 30px;
  }
  .af-superadmin-branding-toggle-wrap {
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .af-superadmin-branding-toggle-label {
    display: flex;
  }
`;
